export default __webpack_public_path__ + "assets/images/03b19d038525202584890e756db144af.svg";